import { Component, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DialogResult, PopupDialog } from '@app/Common';
import { CreateTenantDto } from '@app/Models/create-tenant.dto';
import { Tenant } from '@app/Models/tenant';
import { Observable, Subject } from 'rxjs';
import { tap } from 'rxjs/operators';
import { CloneService } from '../../Services';
import { UntypedFormControl, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ImportIdValidator } from '@app/Tenant/Validators';
import { AsyncPipe } from '@angular/common';
import { JobStatusPlaceholderComponent } from '../../../../../Common/job-status-placeholder/job-status-placeholder.component';
import { MatButton } from '@angular/material/button';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatIcon } from '@angular/material/icon';
import { NewTenantFormComponent } from '../../../../Components/NewTenantForm/new-tenant-form.component';

@Component({
    selector: 'app-clone-import-only',
    templateUrl: './clone-import-only.component.html',
    styleUrls: [
        './clone-import-only.component.scss'
    ],
    imports: [JobStatusPlaceholderComponent, MatButton, FormsModule, MatFormField, MatLabel, MatInput, ReactiveFormsModule, MatIcon, NewTenantFormComponent, AsyncPipe]
})
export class CloneImportOnlyComponent implements OnDestroy {
  cloneInProgress$: Observable<boolean>;
  cloneFinalised$: Observable<boolean>;
  cloneJobId$: Observable<string>;
  importId: UntypedFormControl = new UntypedFormControl('', [], [this.importIdValidator.getValidator()]);

  private isDestroyed$ = new Subject<void>();

  constructor(
    private cloneService: CloneService,
    private dialog: MatDialog,
    private importIdValidator: ImportIdValidator
  ) {
    this.cloneInProgress$ = this.cloneService.cloneInProgress$.asObservable();
    this.cloneFinalised$ = this.cloneService.cloneFinalised$.asObservable();
    this.cloneJobId$ = this.cloneService.cloneJobId$.asObservable();
  }

  ngOnDestroy(): void {
      this.isDestroyed$.complete();
  }

  cloneAnotherTenant(): void {
    location.reload();
  }

  openCloneConfirmationPopup(createTenantDto: CreateTenantDto): void {
    const newTenant: Tenant = {
      ...createTenantDto
    } as Tenant;

    const dialogRef =
      this.dialog.open<PopupDialog, any, DialogResult>(PopupDialog);
    dialogRef.componentInstance.DialogTitle = 'Clone Import Only';
    dialogRef.componentInstance.DialogDescription =
      'Are you sure you want to Clone <b>Import Only</b>?';
    dialogRef.componentInstance.DialogConfirmButtonText = 'Confirm';
    dialogRef.componentInstance.DialogCancelButtonText = 'Cancel';

    dialogRef.afterClosed().subscribe((result) => {
      if (result !== undefined && result.Result) {
        this.cloneService.cloneInProgress$.next(true);
        this.clone(newTenant);
      } else {
        this.cloneService.cloneInProgress$.next(false);
      }
    });
  }

  clone(newTenant: Tenant): void {
    this.cloneService.cloneImportOnlyRequest(newTenant, this.importId.value)
      .subscribe();
  }

  isImportIdValid(): boolean {
    return this.importId?.valid ?? false;
  }

  isCloneAvailable(): boolean {
    return this.isImportIdValid();
  }
}
